import { render, staticRenderFns } from "./DrugFormulationSelect.vue?vue&type=template&id=381d6a31&"
import script from "./DrugFormulationSelect.vue?vue&type=script&lang=js&"
export * from "./DrugFormulationSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports